import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../assets/css/SlimSlider.css';

function ImageSlider() {
    const settings = {
        dots: true, // Display dots for navigation
        infinite: true, // Loop the slider
        speed: 500, // Transition speed in milliseconds
        slidesToShow: 1, // Number of slides to show at once
        slidesToScroll: 1, // Number of slides to scroll
        autoplay: true, // Autoplay the slider
        autoplaySpeed: 3000, // Autoplay speed in milliseconds
        className: "slides"
    };

    return (
        <div className="fullscreen-slider">

        <Slider  {...settings}>
            <div className="fullscreen-slide">
                <img src="/images/slider11.jpg" className={'m-auto'} alt="Slide 1" />
            </div>
            <div className="fullscreen-slide">
                <img src="/images/slide-02.jpg" className={'m-auto'} alt="Slide 1" />
            </div>
            {/* Add more slides as needed */}
        </Slider>
        </div>
    );
}

export default ImageSlider;